import { DocumentViewer } from "./DocumentViewer";
import { SourceDataRenderer } from "./SourceDataRenderer";
import WorkflowForm from "./WorkflowForm";

const DynamicWorkflowForm = ({
  workflow,
  contextData,
  currentNode,
  automationId,
  sourceDataRenderer,
  interfaceDefinition,
  onRunAutomation,
  isLoading,
}) => {
  return (
    <div className="grid grid-cols-[2fr_3fr]" style={{ width: "fit-content" }}>
      <div
        className="pb-4 bg-slate-50 bg-opacity-70"
        style={{ minWidth: 400, minHeight: 400 }}
      >
        <div className="px-4">
          {contextData ? (
            <div>
              <SourceDataRenderer
                currentNode={currentNode}
                sourceData={contextData}
                sourceDataRenderer={sourceDataRenderer}
              />
            </div>
          ) : (
            <div className="w-full text-slate-500 h-full text-xs rounded-lg m-2">
              Nothing to review
            </div>
          )}
        </div>
      </div>
      <div className="">
        <WorkflowForm
          workflow={workflow}
          currentNode={currentNode}
          interfaceDefinition={interfaceDefinition}
          automationId={automationId}
          contextData={contextData}
          onRunAutomation={onRunAutomation}
          isLoading={isLoading}
        />
      </div>
    </div>
  );
};

export default DynamicWorkflowForm;
